<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Usuarios</div>
      <div slot="sub-title">Administración de usuarios</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button icon-left="plus" type="is-primary" @click="openCreateModal">Crear Usuario</b-button>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <users-table @edit="editUser" @view="viewUser" :reload.sync="reloadTable"/>
    </section>
    <user-form-modal :active.sync="createModalActive" :user-id.sync="userIdSelected" :view-mode="viewMode" @saved="reloadTable = true" style="padding-top: 0.5rem"/>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import UsersTable from './components/UsersTable'
import UserFormModal from './components/UserFormModal'

export default {
  components: {
    HeroBar,
    UsersTable,
    UserFormModal
  },
  data () {
    return {
      createModalActive: false,
      userIdSelected: null,
      reloadTable: false,
      viewMode: false
    }
  },
  methods: {
    openCreateModal () {
      this.createModalActive = true
    },
    editUser (data) {
      if (data) {
        this.userIdSelected = data
        this.createModalActive = true
        this.viewMode = false
      }
    },
    viewUser (data) {
      if (data) {
        this.userIdSelected = data
        this.createModalActive = true
        this.viewMode = true
      }
    }
  }
}
</script>
